import React from "react";

export const MapEmbed = () => (
  <div>
    <h3 style={{ letterSpacing: '2px', fontSize: '1.5rem', marginBottom: "1rem", textAlign: 'center', fontFamily:'"Playfair Display", Georgia, serif', fontWeight: 'normal' }}>Visit Us at I.T.O. Insurance Agency</h3>
    <div
      style={{
        width: "100%",
        height: "30rem",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <iframe
        title="I.T.O. Insurance Agency"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13237.928905744558!2d-117.9520165!3d33.7771001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dd2938c09cfa2d%3A0xa178a6e116ca64ec!2s12818%20Brookhurst%20St%2C%20Garden%20Grove%2C%20CA%2092840!5e0!3m2!1sen!2sus!4v1712961582021!5m2!1sen!2sus"
      ></iframe>
    </div>
  </div>
);
